import { Component, OnInit, ViewChild } from '@angular/core';
import {
  PoMenuItem,
  PoModalAction,
  PoModalComponent,
  PoMultiselectOption,
  PoSelectOption,
  PoToolbarAction,
} from '@po-ui/ng-components';
import { Token } from 'src/classes/Token';
import { LoginService } from '../login/login.service';
import { SquadsService } from '../squads/squads.service';
import { UsersService } from '../users/users.service';
import { CompetencyProfileService } from '../compentecy-profile/competency-profile.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})
export class HomeComponent implements OnInit {
  @ViewChild('registerUsers', { static: true }) selectUsers!: PoModalComponent;

  public name = '';
  public selectedRoles: Array<string> = [];
  // public selectedCareer: Array<string> = [];
  public selectedSquads: Array<number> = [];
  public selectedJobCareer: any;

  public roles: Array<PoSelectOption> = [];
  public career: Array<PoSelectOption> = [];
  public squads: Array<PoMultiselectOption> = [];
  public jobCareer = [];

  readonly menus: Array<PoMenuItem> = [
    {
      label: 'Home',
      icon: ' an an-house-line',
      shortLabel: 'Home',
      link: '/home',
    },
  ];

  profileActions: Array<PoToolbarAction> = [
    {
      icon: 'an an-sign-out',
      label: 'Sair',
      type: 'danger',
      separator: true,
      action: (user: any) => this.loginService.logout(),
    },
  ];

  close: PoModalAction = {
    action: () => {
      this.selectUsers.close();
    },
    label: 'Cancelar',
    danger: true,
  };

  save: PoModalAction = {
    action: () => {
      this.saveUserData();
    },
    label: 'Salvar',
  };

  constructor(
    public loginService: LoginService,
    public squadService: SquadsService,
    public usersService: UsersService,
    public competencyProfile: CompetencyProfileService
  ) { }

  async ngOnInit(): Promise<void> {
    this.getSquads();
    this.roles = this.usersService.getRoles([], true);
    this.career = this.usersService.getCareer('');
    await this.competencyProfile.getJobCareerOptions();
    this.selectedRoles = this.loginService.userToken.roles;

    if (this.loginService.userToken.token === '') {
      this.loginService.validSession();
    }
    if (
      !this.loginService.userToken.squads[0] ||
      !this.loginService.userToken.roles[0]
    ) {
      this.selectUsers.open();
    }

    this.setupMenus()

  }

  setupMenus() {
    const userToken = this.loginService.userToken;
    const userRoles = this.loginService.userToken.roles;
    const isAdmin = userRoles.includes('admin');
    const isCoach = userRoles.includes('agilecoach');
    const isLead = userRoles.includes('teamlead');
    const isTribe = userRoles.includes('tribelead');
    const isEpic = userRoles.includes('epicowner');
    const isProductManager = userRoles.includes('productmanager');
    const isProductOwner = userRoles.includes('productowner');

    if (userToken.approved) {
      if (isAdmin) {
        this.addAdminMenus();
      }
      if (!isAdmin && !isCoach && isLead) {
        this.addTeamLeadMenus();
      }
      if (!isAdmin && !isLead && !isCoach && isTribe) {
        this.addTribeLeadMenus();
      }
      if (!isAdmin && isCoach) {
        this.addAgileCoachMenus();
      }
      if (!isAdmin && !isLead && !isCoach && !isTribe && (isProductManager || isProductOwner)) {
        this.addProductManagerAndProductOwner();
      }
      if (!userToken.roles.some(role => ['admin', 'teamlead', 'tribelead', 'agilecoach', 'productmanager', 'productowner'].includes(role))) {
        this.addDefaultMenus();
      }
    }
  }

  addAdminMenus() {
    this.menus.push({
      label: 'Agile Game',
      icon: ' an an-file-text',
      shortLabel: 'Agile Game',
      link: '/agile-game',
      subItems: [
        { label: 'Equipe', link: '/agile-game/team' },
        { label: 'Meu Planejamento', link: '/agile-game/team-planning' },
        { label: 'Orçado X Realizado', link: '/agile-game/achieved-goals' },
        { label: 'MVT', link: '/agile-game/mvt' },
        {
          label: 'Apuração',
          icon: '',
          link: '/counting',
          shortLabel: 'Apuração',
          subItems: [
            { label: 'Apuração Coletiva', link: '/counting/calculation-collective' },
            { label: 'Apuração Individual', link: '/counting/individual' },
          ],
        },
        {
          label: 'Histórico',
          icon: ' an an-clock-counter-clockwise',
          shortLabel: 'Histórico',
          link: '/history',
          subItems: [{ label: 'Minhas Metas', link: '/history/my-goals' }],
        },
        { label: 'Relatório de Acessos', link: '/agile-game/user-log' },
      ],
    });
    this.menus.push({
      label: 'Matriz de Competências',
      icon: ' an an-lightbulb',
      shortLabel: 'Matriz',
      link: '/matrix-competency',
      subItems: [
        { label: 'Grupo de Competências', link: '/matrix-competency/group-competences' },
        { label: 'Competências', link: '/matrix-competency/competences' },
        { label: 'Configuração do Book de Carreira', link: '/matrix-competency/competency-profile' },
        { label: 'Configuração da Matriz', link: '/matrix-competency/config-matriz' },
        { label: 'Matriz de Competências', link: '/matrix-competency/matrix' },
        { label: 'Avaliação 180°', link: '/matrix-competency/leader-assessment' },
      ],
    });
    this.menus.push({
      label: 'Dashboard',
      icon: ' an an-chart-bar',
      shortLabel: 'Dashboard',
      link: '/dashboard-matrix',
      subItems: [
        { label: 'Vulnerabilidade', link: '/dashboard-matrix/operational-vulnerability-dashboard' },
        { label: 'Efetividade', link: '/dashboard-matrix/plan-effectiveness-dashboard' },
        { label: 'Extrato Avaliação 180°', link: '/dashboard-matrix/report-matrix' },
      ],
    });
    this.menus.push({
      label: 'Opções Administrativas',
      icon: ' an an-gear',
      shortLabel: 'Opções',
      subItems: [
        { label: 'Aprovação de Usuários', link: '/adm/approve' },
        { label: 'Ciclos', link: '/adm/cicles' },
        { label: 'Competências', link: '/adm/competence' },
        { label: 'Tipo de Competências', link: '/adm/competence-type' },
        { label: 'Equipes', link: '/adm/squads' },
        { label: 'Metas', link: '/adm/goals' },
        { label: 'Peso das Metas', link: '/adm/goal-weight' },
        { label: 'Tribes', link: '/adm/tribes' },
        { label: 'Usuários', link: '/adm/users' },
        { label: 'Worker', link: '/adm/worker' }
      ],
    });
  }

  addTeamLeadMenus() {
    this.menus.push({
      label: 'Agile Game',
      icon: ' an an-file-text',
      shortLabel: 'Agile Game',
      link: '/agile-game',
      subItems: [
        { label: 'Equipe', link: '/agile-game/team' },
        { label: 'Meu Planejamento', link: '/agile-game/team-planning' },
        { label: 'Orçado X Realizado', link: '/agile-game/achieved-goals' },
        { label: 'MVT', link: '/agile-game/mvt' },
        {
          label: 'Apuração',
          icon: '',
          link: '/counting',
          shortLabel: 'Apuração',
          subItems: [
            { label: 'Apuração Coletiva', link: '/counting/calculation-collective' },
            { label: 'Apuração Indivídual', link: '/counting/individual' },
          ],
        },
        {
          label: 'Histórico',
          icon: ' an an-clock-counter-clockwise',
          shortLabel: 'Histórico',
          link: '/history',
          subItems: [{ label: 'Minhas Metas', link: '/history/my-goals' }],
        },
        { label: 'Relatório de Acessos', link: '/agile-game/user-log' },

      ],
    });
    this.menus.push({
      label: 'Matriz de Competências',
      icon: ' an an-lightbulb',
      shortLabel: 'Matriz',
      link: '/matrix-competency',
      subItems: [
        { label: 'Configuração da Matriz', link: '/matrix-competency/config-matriz' },
        { label: 'Matriz de Competências', link: '/matrix-competency/matrix' },
        { label: 'Avaliação 180°', link: '/matrix-competency/leader-assessment' },
      ],
    });
    this.menus.push({
      label: 'Dashboard',
      icon: ' an an-chart-bar',
      shortLabel: 'Dashboard',
      link: '/dashboard-vulnerabillity',
      subItems: [
        { label: 'Vulnerabilidade', link: '/dashboard-matrix/operational-vulnerability-dashboard' },
        { label: 'Efetividade', link: '/dashboard-matrix/plan-effectiveness-dashboard' },
        { label: 'Extrato Avaliação 180°', link: '/dashboard-matrix/report-matrix' },
      ],
    });
  }

  addTribeLeadMenus() {
    this.menus.push({
      label: 'Agile Game',
      icon: ' an an-file-text',
      shortLabel: 'Agile Game',
      link: '/agile-game',
      subItems: [
        { label: 'Meu Planejamento', link: '/agile-game/team-planning' },
        { label: 'Orçado X Realizado', link: '/agile-game/achieved-goals' },
        {
          label: 'Apuração',
          icon: '',
          link: '/counting',
          shortLabel: 'Apuração',
          subItems: [
            { label: 'Apuração Coletiva', link: '/counting/calculation-collective' },
            { label: 'Apuração Indivídual', link: '/counting/individual' }
          ],
        },
        {
          label: 'Histórico',
          icon: ' an an-clock-counter-clockwise',
          shortLabel: 'Histórico',
          link: '/history',
          subItems: [
            { label: 'Minhas Metas', link: '/history/my-goals' },
          ],
        },
        { label: 'Relatório de Acessos', link: '/agile-game/user-log' },
      ],
    });
    this.menus.push({
      label: 'Matriz de Competências',
      icon: ' an an-lightbulb',
      shortLabel: 'Matriz',
      link: '/matrix-competency',
      subItems: [
        { label: 'Configuração da Matriz', link: '/matrix-competency/config-matriz' },
        { label: 'Matriz de Competências', link: '/matrix-competency/matrix' },
      ],
    });
    this.menus.push({
      label: 'Dashboard',
      icon: ' an an-chart-bar',
      shortLabel: 'Dashboard',
      link: '/dashboard-vulnerabillity',
      subItems: [
        { label: 'Vulnerabilidade', link: '/dashboard-matrix/operational-vulnerability-dashboard' },
        { label: 'Efetividade', link: '/dashboard-matrix/plan-effectiveness-dashboard' },
        { label: 'Extrato Avaliação 180°', link: '/dashboard-matrix/report-matrix' },
      ],
    });
  }

  addAgileCoachMenus() {
    this.menus.push({
      label: 'Agile Game',
      icon: ' an an-file-text',
      shortLabel: 'Agile Game',
      link: '/agile-game',
      subItems: [
        { label: 'Equipe', link: '/agile-game/team' },
        { label: 'Meu Planejamento', link: '/agile-game/team-planning' },
        { label: 'Orçado X Realizado', link: '/agile-game/achieved-goals' },
        { label: 'MVT', link: '/agile-game/mvt' },
        {
          label: 'Apuração',
          icon: ' an an-clock-counter-clockwise',
          shortLabel: 'Apuração',
          subItems: [
            { label: 'Apuração Coletiva', link: '/counting/calculation-collective' },
            { label: 'Apuração Indivídual', link: '/counting/individual' },
            { label: 'Avaliação 180°', link: '/matrix-competency/leader-assessment' },
          ],
        },
        {
          label: 'Histórico',
          icon: ' an an-clock-counter-clockwise',
          shortLabel: 'Histórico',
          link: '/history',
          subItems: [
            { label: 'Minhas Metas', link: '/history/my-goals' },
          ],
        },
        { label: 'Relatório de Acessos', link: '/agile-game/user-log' },
      ],
    });
    this.menus.push({
      label: 'Matriz de Competências',
      icon: ' an an-lightbulb',
      shortLabel: 'Matriz',
      link: '/matrix-competency',
      subItems: [
        { label: 'Configuração da Matriz', link: '/matrix-competency/config-matriz' },
        { label: 'Matriz de Competências', link: '/matrix-competency/matrix' },
      ],
    });
    this.menus.push({
      label: 'Dashboard',
      icon: ' an an-chart-bar',
      shortLabel: 'Dashboard',
      link: '/dashboard-vulnerabillity',
      subItems: [
        { label: 'Vulnerabilidade', link: '/dashboard-matrix/operational-vulnerability-dashboard' },
        { label: 'Efetividade', link: '/dashboard-matrix/plan-effectiveness-dashboard' },
        { label: 'Extrato Avaliação 180°', link: '/dashboard-matrix/report-matrix' },
      ],
    });
    this.menus.push({
      label: 'Opções Administrativas',
      icon: ' an an-gear',
      shortLabel: 'Opções',
      subItems: [
        { label: 'Ciclos', link: '/adm/cicles' },
        { label: 'Competências', link: '/adm/competence' },
        { label: 'Tipo de Competências', link: '/adm/competence-type' },
        { label: 'Equipes', link: '/adm/squads' },
        { label: 'Peso das Metas', link: '/adm/goal-weight' },
        { label: 'Tribes', link: '/adm/tribes' },
      ],
    });
  }

  addProductManagerAndProductOwner() {
    this.menus.push({
      label: 'Agile Game',
      icon: ' an an-file-text',
      shortLabel: 'Agile Game',
      link: '/agile-game',
      subItems: [
        { label: 'Meu Planejamento', link: '/agile-game/team-planning' },
        { label: 'Orçado X Realizado',link: '/agile-game/achieved-goals'},
        {
          label: 'Apuração',
          icon: '',
          link: '/counting',
          shortLabel: 'Apuração',
          subItems: [
            { label: 'Apuração Coletiva', link: '/counting/calculation-collective' },
             { label: 'Apuração Indivídual', link: '/counting/individual' }
          ],
        },
        {
          label: 'Histórico',
          icon: ' an an-clock-counter-clockwise',
          shortLabel: 'Histórico',
          link: '/history',
          subItems: [
            { label: 'Minhas Metas', link: '/history/my-goals' },
          ],
        },
        { label: 'Relatório de Acessos', link: '/agile-game/user-log' },
      ],
    });
    this.menus.push({
      label: 'Matriz de Competências',
      icon: ' an an-lightbulb',
      shortLabel: 'Matriz',
      link: '/matrix-competency',
      subItems: [
        { label: 'Configuração da Matriz', link: '/matrix-competency/config-matriz' },
        { label: 'Matriz de Competências', link: '/matrix-competency/matrix' },
      ],
    });
    this.menus.push({
      label: 'Dashboard',
      icon: ' an an-chart-bar',
      shortLabel: 'Dashboard',
      link: '/dashboard-vulnerabillity',
      subItems: [
        { label: 'Vulnerabilidade', link: '/dashboard-matrix/operational-vulnerability-dashboard' },
        { label: 'Efetividade', link: '/dashboard-matrix/plan-effectiveness-dashboard' }
      ],
    });
  }

  addDefaultMenus() {
    this.menus.push({
      label: 'Agile Game',
      icon: ' an an-file-text',
      shortLabel: 'Agile Game',
      link: '/agile-game',
      subItems: [
        {
          label: 'Orçado X Realizado',
          link: '/agile-game/achieved-goals',
        },
        {
          label: 'Apuração',
          icon: '',
          link: '/counting',
          shortLabel: 'Apuração',
          subItems: [
            { label: 'Apuração Coletiva', link: '/counting/calculation-collective' },
          ],
        },
        {
          label: 'Histórico',
          icon: ' an an-clock-counter-clockwise',
          shortLabel: 'Histórico',
          link: '/history',
          subItems: [
            { label: 'Minhas Metas', link: '/history/my-goals' },
          ],
        },
        { label: 'Relatório de Acessos', link: '/agile-game/user-log' },
      ],
    });
    this.menus.push({
      label: 'Matriz de Competências',
      icon: ' an an-lightbulb',
      shortLabel: 'Matriz',
      link: '/matrix-competency',
      subItems: [
        { label: 'Configuração da Matriz', link: '/matrix-competency/config-matriz' },
        { label: 'Matriz de Competências', link: '/matrix-competency/matrix' },
      ],
    });
    this.menus.push({
      label: 'Dashboard',
      icon: ' an an-chart-bar',
      shortLabel: 'Dashboard',
      link: '/dashboard-vulnerabillity',
      subItems: [
        { label: 'Vulnerabilidade', link: '/dashboard-matrix/operational-vulnerability-dashboard' },
        { label: 'Efetividade', link: '/dashboard-matrix/plan-effectiveness-dashboard' }
      ],
    });
  }

  getSquads() {
    this.squadService.get().subscribe((squads) => {
      squads.forEach((squad: any) => {
        this.squads = [
          ...this.squads,
          {
            label: `${squad.tribeSegment}-${squad.tribeName}-${squad.name}`,
            value: squad.id,
          },
        ];
      });
      this.selectedSquads = this.loginService.userToken.squads;
    });
  }

  async saveUserData() {
    const careerName = await this.competencyProfile.getJobCareerById(this.selectedJobCareer)
    const tokenUser: Token = Object.assign(
      {},
      {
        id: this.loginService.userToken.id,
        username: this.loginService.userToken.username,
        name: this.name,
        squads: this.selectedSquads,
        roles: this.selectedRoles,
        career: careerName.career.name,
        token: this.loginService.userToken.token,
        approved: this.loginService.userToken.approved,
        jobCareer: this.selectedJobCareer
      }
    );

    if (this.name != '' && this.selectedSquads.length != 0 && this.selectedJobCareer) {
      this.loginService.changeDataUser(tokenUser).subscribe((res) => {
        this.loginService.handleMessage(
          'Usuário salvo com sucesso, aguarde a aprovação do Administrador para ter acesso aos recursos.',
          1
        );
        this.selectUsers.close();
      });
    }
    else {
      this.loginService.handleMessage('Não foi possível salvar o usuário. Preencha todos os campos para prosseguir.');
    }

  }
}
